import type { WebViewIntent } from '@/lib/react-native/services/react-native.intent'
import { createIntent } from '@/lib/react-native/services/react-native.intent'

export function createViewPdfIntent({ pdfLink }: { pdfLink: string }): WebViewIntent {
  return createIntent('VIEW_PDF', {
    pdfLink,
  })
}
